// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__cxilD","menu":"Navbar_menu__InuLo","mobile_btn":"Navbar_mobile_btn__gV33A","active":"Navbar_active__HYDN1"};